var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolesSideBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24H8.5C8.22 24 8 23.78 8 23.5C8 23.22 8.22 23 8.5 23H23.5C23.78 23 24 23.22 24 23.5C24 23.78 23.78 24 23.5 24Z",
    fill: "#201E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.66 24H10.34C10.06 24 9.84 23.78 9.84 23.5V8.5C9.84 8.22 10.06 8 10.34 8H21.65C21.93 8 22.15 8.22 22.15 8.5V23.5C22.15 23.78 21.93 24 21.65 24H21.66ZM10.84 23H21.15V9H10.84V23Z",
    fill: "#201E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H14C13.72 24 13.5 23.78 13.5 23.5V19.5C13.5 19.22 13.72 19 14 19H18C18.28 19 18.5 19.22 18.5 19.5V23.5C18.5 23.78 18.28 24 18 24ZM14.5 23H17.5V20H14.5V23Z",
    fill: "#201E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 12.31H12.81C12.53 12.31 12.31 12.09 12.31 11.81C12.31 11.53 12.53 11.31 12.81 11.31H14.81C15.09 11.31 15.31 11.53 15.31 11.81C15.31 12.09 15.09 12.31 14.81 12.31Z",
    fill: "#201E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.19 12.31H17.19C16.91 12.31 16.69 12.09 16.69 11.81C16.69 11.53 16.91 11.31 17.19 11.31H19.19C19.47 11.31 19.69 11.53 19.69 11.81C19.69 12.09 19.47 12.31 19.19 12.31Z",
    fill: "#201E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 15.65H12.81C12.53 15.65 12.31 15.43 12.31 15.15C12.31 14.87 12.53 14.65 12.81 14.65H14.81C15.09 14.65 15.31 14.87 15.31 15.15C15.31 15.43 15.09 15.65 14.81 15.65Z",
    fill: "#201E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.19 15.65H17.19C16.91 15.65 16.69 15.43 16.69 15.15C16.69 14.87 16.91 14.65 17.19 14.65H19.19C19.47 14.65 19.69 14.87 19.69 15.15C19.69 15.43 19.47 15.65 19.19 15.65Z",
    fill: "#201E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolesSideBarIcon);
export default __webpack_public_path__ + "static/media/polesSideBarIcon.2a1ef5f391f89d1668d31a07c48b048d.svg";
export { ForwardRef as ReactComponent };